import React from "react";
import Styles from "../components/Contatos.module.css";
import logoClube from "../img/RC.png";
import { FaInstagram, FaEnvelope, FaPhone } from "react-icons/fa"; 

const Contatos = () => {
  return (
    <div className={Styles.contatoContainer}>
      <div className={Styles.textContainer}>
        <h2>Fale conosco</h2>
        
        <p>
          <span className={Styles.icon}><FaEnvelope size={20} /></span> 
          <a href="mailto:suporte@rafaellachijner.com.br">suporte@rafaellachijner.com.br</a>
        </p>
        
        <p>
          <span className={Styles.icon}><FaPhone size={20} /></span> 
          <a href="tel:+5521990766280">+55 21 99076-6280</a>
        </p>
        
        <h3>Nos acompanhe no Instagram</h3>
        
        <p>
          <span className={Styles.icon}><FaInstagram size={20} /></span> 
          <a href="https://instagram.com/repertoriodevalor" target="_blank" rel="noopener noreferrer">
            @repertoriodevalor
          </a>
        </p>
        
        <p>
          <span className={Styles.icon}><FaInstagram size={20} /></span> 
          <a href="https://instagram.com/rafachijner" target="_blank" rel="noopener noreferrer">
            @rafachijner
          </a>
        </p>
      </div>
      
      <div className={Styles.logoContainer}>
        <img src={logoClube} alt="Logo do Clube" className={Styles.logo} />
      </div>
    </div>
  );
};

export default Contatos;
